export const MessageType = {
  FACEBOOK: "facebook",
  INSTAGRAM: "instagram",
  WEB: "web",
  WHATSAPP: "whatsapp",
}
